// Preserve legacy row rendering and keys during migration.
/* eslint-disable arrow-body-style, react/no-array-index-key, prefer-template */
import type { SetPositionProductType } from 'utils/apiList/setPosition'
import { memo } from 'react'
import styled from 'styled-components'
import { SystemIcon, RowSetPositionProduct } from 'components'

interface TableSetPositionProductPropsType {
  data?: SetPositionProductType[]
  handleChangeActive?: unknown
  handleClickDetail?: unknown
  handleClickUpdate?: unknown
  isAllowedForSetPosition?: boolean
}

function TableSetPositionProduct({
  data,
  handleChangeActive: _handleChangeActive,
  handleClickDetail: _handleClickDetail,
  handleClickUpdate: _handleClickUpdate,
  isAllowedForSetPosition,
}: TableSetPositionProductPropsType) {
  return (
    <>
      <Container>
        <thead>
          <Tr>
            <Th ratio="4">
              NAMA PRODUCT
              <SystemIcon iconName="up-and-down" fontSize="smallest" className="ml-3" />
            </Th>
            <Th ratio="3">NOMER SKU</Th>
            <Th ratio="2">SET POSITION</Th>
            <Th ratio="1" />
          </Tr>
        </thead>
        <tbody>
          {data?.map((items, index) => {
            return (
              <RowSetPositionProduct
                isAllowedForSetPosition={isAllowedForSetPosition}
                data={items}
                key={'sada' + index + 'sa'}
              />
            )
          })}
        </tbody>
      </Container>
    </>
  )
}

export default memo(TableSetPositionProduct)

const Container = styled.table`
  width: 100%;
`
const Tr = styled.tr`
  display: flex;
  padding: 16px 32px;
  background-color: ${({ theme: { colors } }) => colors.tableHead};
`
const Th = styled.th<{ ratio: string }>`
  color: ${({ theme: { colors } }) => colors.grey};
  /* font-weight: ${({ theme: { fontWeights } }) => fontWeights.light}; */
  font-size: ${({ theme: { fontSizes } }) => fontSizes.smaller};
  flex: ${({ ratio }) => ratio};
  text-align: start;
`
